import { useTranslation } from 'react-i18next';
import { useIsAdpWfnCanadaConnectedOrg } from '@/hooks/useIsAdpWfnCanadaConnectedOrg';

export type LocalizedHrisName = {
  text: string;
  secondaryText?: string;
};

export const getLocalizedHrisName = (
  english: string | null | undefined,
  frenchCa: string | null | undefined,
  language: string,
  isAdpWfnCanada: boolean
): LocalizedHrisName => {
  const en = english ?? '';
  if (!isAdpWfnCanada || !frenchCa) {
    return { text: en };
  }
  return language.startsWith('fr')
    ? { text: frenchCa, secondaryText: en }
    : { text: en, secondaryText: frenchCa };
};

export const useLocalizedHrisName = () => {
  const { i18n } = useTranslation();
  const isAdpWfnCanada = useIsAdpWfnCanadaConnectedOrg();

  return (
    english: string | null | undefined,
    frenchCa: string | null | undefined
  ) => getLocalizedHrisName(english, frenchCa, i18n.language, isAdpWfnCanada);
};

/**
 * Single-line variant for contexts that can't stack two lines: text
 * interpolated into a translated sentence (toasts, <Trans> messages) or
 * packed into a pill/chip. Same ordering rule, "Primary (Secondary)".
 */
export const getLocalizedHrisNameText = (
  english: string | null | undefined,
  frenchCa: string | null | undefined,
  language: string,
  isAdpWfnCanada: boolean
): string => {
  const { text, secondaryText } = getLocalizedHrisName(
    english,
    frenchCa,
    language,
    isAdpWfnCanada
  );
  return secondaryText ? `${text} (${secondaryText})` : text;
};

export const useLocalizedHrisNameText = () => {
  const { i18n } = useTranslation();
  const isAdpWfnCanada = useIsAdpWfnCanadaConnectedOrg();

  return (
    english: string | null | undefined,
    frenchCa: string | null | undefined
  ) =>
    getLocalizedHrisNameText(english, frenchCa, i18n.language, isAdpWfnCanada);
};
